/**
 * Universidad de La Laguna
 * Escuela Superior de Ingeniería y Tecnología
 * Grado en Ingeniería Informática
 * Programación de Aplicaciones Interactivas
 *
 * @author Jose Angel Portillo Garcia
 * @author Alejandro Feo Martin
 * @author Kyliam Gabriel Chinea Salcedo
 * @since Apr 29 2026
 * @desc Main scene class that manages the instantiation of
 *              different rectangle game objects.
 */

import * as Phaser from 'phaser';

/**
 * @classdesc Scene demonstrating the core Phaser lifecycle methods and their execution order.
 */
export class LifecycleDemo extends Phaser.Scene {
  constructor() {
    super('LifecycleDemo');
  }

  /**
   * @desc First lifecycle phase: initializes variables and data.
   */
  init(): void {
    console.log('1. INIT: Preparando el escenario (Variables y datos)');
  }

  /**
   * @desc Second lifecycle phase: loads images and sounds.
   */
  preload(): void {
    console.log('2. PRELOAD: Descargando imágenes y sonidos de internet');
  }

  /**
   * @desc Third lifecycle phase: creates game objects.
   */
  create(): void {
    console.log('3. CREATE: Poniendo a los actores en el escenario');
  }

  /**
   * @desc Fourth lifecycle phase: runs every frame (empty in this demo).
   */
  update(): void {
  }
}